<template lang="pug">
a.hover-link(
  v-if="enabled"
  v-tooltip="tooltip"
  :href="href"
  v-bind="$attrs"
  :title="title"
)
  slot
  i(:class="{ [icon]: true, edit: true }")
span(v-else)
  slot
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
    href: {
      type: String,
    },
    title: {
      type: String,
    },
    tooltip: {
      type: Object,
      default: () => ({ placement: 'right', delay: { show: 1200, hide: 0 } }),
    },
    icon: {
      type: String,
      default: 'hi hi-edit-xs',
    },
  },
};
</script>
